import { api } from '@/lib/api';

export type DoctorTeamBranding = {
  teamLeadId: string;
  teamLeadName: string;
  logoUrl: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  sidebarBgColor: string;
  customUiColors: boolean;
  doctorLeadSourceKey: string;
  doctorLeadSourceLabel: string;
};

export type DoctorTeamDashboard = {
  teamLead: { id: string; name: string };
  period: { from: string; to: string };
  summary: {
    opdPatients: number;
    opdRevenue: number;
    procedurePatients: number;
    procedureRevenue: number;
    packagePatients: number;
    packageRevenue: number;
    totalRevenue: number;
    doctorLeadPatients: number;
    trueLeadPatients: number;
  };
  byDoctor: Array<{
    doctorId: string;
    doctorName: string;
    opdPatients: number;
    opdRevenue: number;
    procedurePatients: number;
    procedureRevenue: number;
    packagePatients: number;
    packageRevenue: number;
    totalRevenue: number;
  }>;
  patients: Array<{
    patientId: string;
    patientName: string;
    phone: string;
    leadBucket: 'DOCTOR_LEAD' | 'TRUE_LEAD';
    leadBucketLabel: string;
    rawSource: string | null;
    category: 'OPD' | 'PROCEDURE' | 'PACKAGE';
    doctorName: string;
    amount: number;
    serviceAt: string;
  }>;
};

export const doctorTeamApi = {
  getDashboard: (params?: { from?: string; to?: string }) =>
    api.get<{ message: string; data: DoctorTeamDashboard }>('/api/doctor-team/dashboard', { params }),

  getBranding: () =>
    api.get<{ message: string; data: DoctorTeamBranding | null }>('/api/doctor-team/branding'),

  listTeamLeads: (hospitalId?: string) =>
    api.get<{ message: string; data: { items: Array<{ id: string; name: string; email: string }> } }>(
      '/api/doctor-team/team-leads',
      { params: hospitalId ? { hospitalId } : undefined }
    ),

  listLeadSources: (hospitalId?: string) =>
    api.get<{ message: string; data: { sources: Array<{ value: string; label: string }> } }>(
      '/api/doctor-team/lead-sources',
      { params: hospitalId ? { hospitalId } : undefined }
    ),
};
